<template>
  <section class="product-container mb-0 pb-0">
    <div v-if="loading">
      <div class="text-center w-full">
        <div
          class="text-center"
          style="padding-top: 100px; padding-bottom: 50px"
        >
          <span
            class="fa-solid fa-spinner fa-spin text-[#2463EB]"
            style="font-size: 8rem"
          ></span>
          <h3
            class="text-center pt-[24px] text-[16px] font-medium leading-[16.94px]"
            style="padding-bottom: 100px"
          >
            Please wait while we loading the product's list
          </h3>
        </div>
      </div>
    </div>
    <div
      v-else
      class="flex flex-col md:flex-row items-center gap-[6px] w-full items-stretch pb-0 mb-0"
      v-for="(p, index) in Products"
      :key="index"
    >
      <div
        class="md:w-[30%] bg-white rounded-[8px] mb-[6px] p-[20px] self-stretch"
      >
        <div class="flex items-center justify-center h-full">
          <img
            v-if="p.imageUrl"
            :src="p.imageUrl"
            alt="logo"
            class="max-w-[150px] mx-auto h-[150px] w-full object-contain"
          />
          <img
            v-else
            class="max-w-[150px] mx-auto h-[150px] w-full object-contain"
            src="/assets/img/avatar.svg"
            alt="logo"
          />
        </div>
      </div>
      <div
        class="md:w-[70%] bg-white rounded-[8px] mb-[6px] p-[20px] pb-[60px] md:p-[20px] relative self-stretch"
      >
        <div
          class="absolute bottom-[15px] md:top-[15px] right-[5px] md:right-[15px] w-[200px] h-[20px] flex items-center gap-[10px]"
        >
          <span
            class="rounded-[20px] px-[12px] py-[6px]"
            :class="[
              'badge',
              { 'badge-success': p.active },
              { 'badge-danger': !p.active },
            ]"
          >
            <span
              class="inline-block w-[10px] h-[10px] rounded-[1px]"
              :style="{
                backgroundColor: p.active ? '#16a249' : '#EF5253',
              }"
            ></span>
            <span class="text-[12px] font-normal">
              {{ p.active ? "Active" : "Inactive" }}
            </span>
          </span>
          <div class="dropdown">
            <button
              class="btn-no-border"
              id="dropdownMenuButton"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <span
                class="text-[#98a2b3] dropdown text-[14px] cursor-pointer relative outline-none active:outline-none shadow-none border-[1.5px] border-[#ccc] px-[12px] py-[6px] rounded-[20px]"
              >
                Actions
                <i class="text-[#9747FF] fas fa-chevron-down text-[12px]"></i>
              </span>
            </button>
            <ul
              class="dropdown-menu shadow-none"
              aria-labelledby="dropdownMenuButton"
            >
              <div>
                <li
                  class="text-[14px] font-normal leading-[20px] text-[#353535] cursor-pointer py-[8px] px-[16px] border-b"
                  v-if="hasPermission('Product_Update')"
                  @click.prevent="viewEditMyProduct(p)"
                >
                  Edit
                </li>
              </div>
              <li
                class="text-[14px] font-normal leading-[20px] text-[#DC2828] cursor-pointer py-[8px] px-[16px]"
                v-if="hasPermission('Product_Delete')"
                @click.prevent="confirmDelete(p.id)"
              >
                Delete Product
              </li>
            </ul>
          </div>
        </div>
        <div>
          <h2 class="text-[16px] font-bold leading-[16.94px] text-[#1e1e1e]">
            {{ p.name }} &nbsp;-&nbsp; &#8358;{{ formatMoney(p.retailPrice) }}
          </h2>
          <p
            class="max-w-[500px] w-full text-[12px] italic font-normal leading-[16.94px] mt-[2px] mb-[10px] text-[#353535]"
          >
            {{ p.description }}
          </p>
        </div>
        <h4
          class="text-[14px] font-medium leading-[16.94px] underline uppercase text-[#353535] mb-[6px]"
        >
          Other Product Information
        </h4>
        <ul>
          <li class="text-[14px] font-medium leading-[16.94px] text-[#353535]">
            <span class="font-normal">Product Category:</span>
            &nbsp;{{ p.category.name }}
          </li>
          <li class="text-[14px] font-medium leading-[16.94px] text-[#353535]">
            <span class="font-normal">Product Unit:</span>
            &nbsp;{{ p.unit }}
          </li>
          <li class="text-[14px] font-medium leading-[16.94px] text-[#353535]">
            <span class="font-normal">Product Code:</span>
            &nbsp;{{ p.code }}
          </li>
          <li class="text-[14px] font-medium leading-[16.94px] text-[#353535]">
            <span class="font-normal">Inventory:</span>
            &nbsp;{{ p.quantity }}
          </li>
          <li class="text-[14px] font-medium leading-[16.94px] text-[#353535]">
            <span class="font-normal">Reorder Level:</span>
            &nbsp;{{ p.minimumStockLevel }}
          </li>
          <li class="text-[14px] font-medium leading-[16.94px] text-[#353535]">
            <span class="font-normal">Date Added:</span>
            &nbsp;{{ formatDate(p.created) }}
          </li>
        </ul>
      </div>
    </div>
    <div
      v-if="!Products.length && !loading"
      class="py-[200px] w-full bg-white text-center text-[16px] font-medium leading-[17px]"
    >
      No Product(s) available
    </div>
  </section>
</template>

<script>
import { helper } from "@/helper";
import moment from "moment";

export default {
  props: [
    "Products",
    "hasPermission",
    "loading",
    "parent",
    "viewEditMyProduct",
    "viewEdit",
    "confirmDelete",
  ],
  computed: {
    user: function() {
      return this.$store.state.currentUser;
    },
  },
  data() {
    return {
      observer: null,
    };
  },

  mounted() {
    this.setupIntersectionObserver();
  },

  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  },

  methods: {
    formatMoney(val) {
      return helper.formatMoney(val);
    },

    formatDate(date) {
      return moment(date).format("lll");
    },
    setupIntersectionObserver() {
      this.observer = new IntersectionObserver(
        (entries) => {
          const target = entries[0];
          if (target.isIntersecting && !this.loading) {
            this.$emit("loadMore");
          }
        },
        {
          root: null,
          rootMargin: "0px",
          threshold: 0.1,
        }
      );

      if (this.$refs.observerTarget) {
        this.observer.observe(this.$refs.observerTarget);
      }
    },
  },

  watch: {
    Products() {
      this.$nextTick(() => {
        if (this.$refs.observerTarget && this.observer) {
          this.observer.disconnect();
          this.observer.observe(this.$refs.observerTarget);
        }
      });
    },
  },
};
</script>
